import useAllergenInfoText from '@/components/page-specific/catering/common/helpers/useAllergenInfoText'
import { DietaryRow } from '@fusion/dietary/row'
import { DialogContent, Typography, Box, Stack } from '@mui/material'

import type React from 'react'
import { useTranslation } from 'react-i18next'
import ReactMarkdown from 'react-markdown'

import type { MenuItem } from '../../domain/menu-item'
import type { MenuVendor } from '../../domain/menu-vendor'

type Props = {
  vendor: Pick<MenuVendor, 'companyName'>
  item: MenuItem
}

export const IngredientsTab: React.FC<Props> = ({ vendor, item }) => {
  const { t } = useTranslation()
  const allergenInfoText = useAllergenInfoText(t)

  return (
    <DialogContent>
      <Stack direction="column" spacing={2} alignItems="flex-start">
        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
          {t('cc:allInformationProvidedBy')} {vendor.companyName}
        </Typography>

        {item.ingredients && (
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', mb: 0.5 }}>
              {t('marketplace:ingredientsList')}
            </Typography>
            <Box sx={{ py: 0.5 }}>
              <Typography variant="caption" sx={{ lineHeight: '24px' }}>
                <ReactMarkdown
                  components={{
                    p: ({ children }) => <span style={{ margin: 0 }}>{children}</span>,
                  }}>
                  {item.ingredients}
                </ReactMarkdown>
              </Typography>
            </Box>
          </Box>
        )}

        {item.dietaries.length > 0 && (
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', mb: 0.5 }}>
              {t('cc:dietaryFlags')}
            </Typography>
            <Box sx={{ py: 0.5 }}>
              <DietaryRow dietaries={item.dietaries} allergens={[]} showLabel />
            </Box>
          </Box>
        )}

        {item.allergens.length > 0 && (
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', mb: 0.5 }}>
              {t('marketplace:allergens')}
            </Typography>
            <Box sx={{ py: 0.5 }}>
              <DietaryRow
                isComboItem={Boolean(item.isCombo)}
                dietaries={[]}
                allergens={item.allergens}
                subAllergens={item.subAllergens}
                showLabel
              />
            </Box>
          </Box>
        )}

        <Box>
          <Typography variant="caption" sx={{ lineHeight: '20px', fontSize: '0.75rem' }}>
            {allergenInfoText}
          </Typography>
        </Box>
      </Stack>
    </DialogContent>
  )
}
